import React from "react";
import { Calendar } from "react-date-range";
import { connect } from "react-redux";
import TimeSlider from "./TimeSlider";
import TimeViewer from "./TimeViewer";
import { addSeconds, startOfDay, isSameDay } from "date-fns";
import { startGetHistory, startSetDcFromHistory } from "../actions/dc";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "../styles/components/timepicker.css";

class TimePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pickedDate: props.pickedDate ? props.pickedDate : new Date(),
      interval: props.interval ? props.interval : 300,
      firstOfRange: props.firstOfTime
        ? props.firstOfTime
        : startOfDay(new Date()),
      endOfRange: props.endOfTime ? props.endOfTime : startOfDay(new Date())
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.close();
    }
  };

  close = () => {
    this.props.toggleTimePicker();
    this.props.startGetHistory(
      this.state.firstOfRange,
      this.state.endOfRange,
      this.state.interval
    );
  };

  handleChange(which, payload) {
    this.setState(
      () => ({
        [which]: payload
      }),
      () => {
        this.props.getPickedDate(this.state.pickedDate);
      }
    );
  }

  onTimeChange = value => {
    const firstOfRange = addSeconds(
      this.state.pickedDate,
      (value[0] * 24 * 60 * 60) / 100
    );

    const endOfRange = addSeconds(
      this.state.pickedDate,
      (value[1] * 24 * 60 * 60) / 100
    );

    this.setState(() => ({
      firstOfRange,
      endOfRange
    }));

    this.props.startSetDcFromHistory(firstOfRange, this.state.interval);

    this.props.getPickedTime([firstOfRange, endOfRange]);
  };

  getInterval = value => {
    this.props.getInterval(value);
    this.setState(() => ({
      interval: value
    }));
  };

  render() {
    return (
      <div className="timepicker">
        <div className="timepicker__body" ref={this.setWrapperRef}>
          <div className="timepicker__body__top">
            <Calendar
              date={this.state.pickedDate}
              onChange={this.handleChange.bind(this, "pickedDate")}
              maxDate={new Date()}
              minDate={new Date(2018, 8, 1)}
            />
            <TimeViewer
              firstTime={this.state.firstOfRange}
              endTime={this.state.endOfRange}
            />
          </div>
          <TimeSlider
            hasHistory={this.props.history ? false : true}
            onChange={this.onTimeChange}
            onChangeInterval={this.getInterval}
            firstOfRange={this.state.firstOfRange}
            endOfRange={this.state.endOfRange}
            interval={this.state.interval}
            isToday={isSameDay(new Date(), this.state.pickedDate)}
          />
          <div className="close" onClick={this.close}>
            <ion-icon name="close" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  history: state.dc.history
});

const mapDispatchToProps = dispatch => ({
  startGetHistory: (startDate, endDate, interval) =>
    dispatch(startGetHistory(startDate, endDate, interval)),
  startSetDcFromHistory: (date, interval) =>
    dispatch(startSetDcFromHistory(date, interval))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimePicker);
